/*!
 * Copyright 2020 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { Patient } from "@app/modules/doctor-panel/models/patient";
import { Observable } from "rxjs";
import { filter, first, map } from "rxjs/operators";

export function validPatientValidator(
  patientsList$: Observable<Map<string, Patient> | null>
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    return patientsList$.pipe(
      filter((list) => !!list), // Wait for availability
      first(),
      map((list) => {
        // No value -> ok
        if (!control.value) {
          return null;
        }

        const patExists = list?.get(control.value);
        return patExists ? null : { notAPatient: { patientId: control.value } };
      })
    );
  };
}
